// extracted by mini-css-extract-plugin
export default {"landingPageContent":"JwZyo4_3IKnRcLTml_0j-LandingPage-landingPageContent"};